import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Outlet, useLocation, Navigate } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "@/components/ui/sonner";

import { AuthProvider, useAuth } from "@/context/AuthContext";
import Nav from "@/components/site/Nav";
import Footer from "@/components/site/Footer";

import Intro from "@/pages/Intro";
import Home from "@/pages/Home";
import Events from "@/pages/Events";
import Gallery from "@/pages/Gallery";
import Tickets from "@/pages/Tickets";
import Signup from "@/pages/Signup";
import TicketView from "@/pages/TicketView";
import PaymentSuccess from "@/pages/PaymentSuccess";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => window.scrollTo(0, 0), [pathname]);
  return null;
}

function SiteLayout() {
  return (
    <div className="grain min-h-screen bg-brand-cream">
      <Nav />
      <main>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}

function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null)
    return <div className="min-h-screen flex items-center justify-center font-mono text-sm">Loading…</div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Intro />} />
            <Route element={<SiteLayout />}>
              <Route path="/home" element={<Home />} />
              <Route path="/events" element={<Events />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/tickets" element={<Tickets />} />
              <Route path="/guest-list" element={<Signup />} />
              <Route path="/ticket/:token" element={<TicketView />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
            </Route>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
          </Routes>
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </ReactLenis>
    </AuthProvider>
  );
}

export default App;
